import {connect} from 'react-redux';
import AuthLogin from '../../../views/auth/AuthLogin';
import {IReduxStoreState} from '../../@interfaces';

export default connect((state: IReduxStoreState) => state.user)(AuthLogin);
